import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import ShopSettingsWithUpdate from '../../../components/layout/ShopSettingsWithUpdate'
import LimitContainer from '../../../components/common/LimitV2/LimitContainer'
import { limitV2Config } from '../../../actions/compliance'

class Limits extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      limits: {},
    }
  }

  componentDidMount() {
    const { shop } = this.props
    const address = shop.address || {}
    this.props.dispatch(limitV2Config(address.state)).then((res) => {
      if (res) {
        this.setState({ limits: res })
      }
    })
  }

  groupCannabisDefinition = (cannabisDefinitions = []) => {
    const grouped = cannabisDefinitions.reduce((acc, item) => {
      const { consumerType, limits } = item
      if (!acc[consumerType]) {
        acc[consumerType] = { consumerType, limits: [...limits] }
      } else {
        acc[consumerType].limits.push(...limits)
      }
      return acc
    }, {})

    const sortedKeys = Object.keys(grouped).sort()
    const sortedGrouped = sortedKeys.map((key) => grouped[key])
    return sortedGrouped
  }

  render() {
    const { limits } = this.state
    const cannabisDefinitions = limits.cannabisDefinition || []
    const groupedItems = this.groupCannabisDefinition(cannabisDefinitions)

    return (
      <div>{groupedItems && groupedItems.map((limits) => <LimitContainer limits={limits} />)}</div>
    )
  }
}

const LimitV2WithTitle = ContainerWithTitleWrapper(Limits, 'Limits')

export default connect(({ dispatch, shopReducer }) => ({
  dispatch,
  shopReducer,
}))(ShopSettingsWithUpdate(LimitV2WithTitle))



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/Limits.js